import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import DropdownList from '../../FormElements/DropdownList';
import PrimaryButton from '../../Buttons/PrimaryButton';
import SecondaryButton from '../../Buttons/SecondaryButton';

export default class PaymentForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			account_type: 'Checking',
			account_number: '',
			routing_number: '',
			account_holder_first_name: this.props.firstName,
			account_holder_last_name: this.props.lastName,
			errorsList: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('PaymentForm', this.props, this.state);
		return (
			<div className="PaymentForm w-full py-4">
				<PageTitle title="Complete your order" />
				<GlobalErrorsBox globalErrors={this.state.errorsList} />
				<FormSection>
					{/*<h2>Select an existing bank account</h2>
					<DropdownList
						label="Bank Account Type *"
						displayLabel={true}
						onChange={this.onChange}
						id="account_type"
						name="account_type"
						value={this.state.account_type}
						data={[
							{
								id: 1,
								name: 'Checking'
							},
							{
								id: 2,
								name: 'Savings'
							}
						]}
					/>
					<h2>Add a new bank account</h2>*/}
					<DropdownList
						label="Bank Account Type *"
						displayLabel={true}
						onChange={this.onChange}
						id="account_type"
						name="account_type"
						value={this.state.account_type}
						data={[
							{
								id: 1,
								name: 'Checking'
							},
							{
								id: 2,
								name: 'Savings'
							}
						]}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="name">Bank Account Nickname *</Label>
					<TextInput
						id="name"
						name="name"
						value={
							this.state.name !== '' ? (
								this.state.name
							) : this.state.account_type === 'Checking' ? (
								`${this.props.firstName}'s Checking`
							) : (
								`${this.props.firstName}'s Savings`
							)
						}
						onChange={this.onChange}
						placeholder={`e.g. ${this.props.firstName}'s Checking`}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="account_number">Bank Account Number</Label>
					<TextInput
						id="account_number"
						name="account_number"
						value={this.state.account_number}
						onChange={this.onChange}
						helperText="Typically 10 digits. e.g. 0100184842"
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="routing_number">Bank Routing Number</Label>
					<TextInput
						id="routing_number"
						type="text"
						name="routing_number"
						value={this.state.routing_number}
						onChange={this.onChange}
						helperText="9 digits. e.g. 302075830"
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="account_holder_first_name">
						Account Holder's First Name
					</Label>
					<TextInput
						id="account_holder_first_name"
						name="account_holder_first_name"
						value={this.state.account_holder_first_name}
						onChange={this.onChange}
						helperText="First name on your account"
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="account_holder_last_name">
						Account Holder's Last Name
					</Label>
					<TextInput
						id="account_holder_last_name"
						name="account_holder_last_name"
						value={this.state.account_holder_last_name}
						onChange={this.onChange}
						helperText="Last name on your account"
						fieldErrors={this.state.fieldErrors}
					/>
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end">
						<FormSubmit onSubmit={this.onSubmit} label="Buy now" />
					</div>
				</div>
				{/*	<PrimaryButton
						label="Test - Back"
						onClick={this.props.backLocation}
					/>
					<SecondaryButton
						label="Test - Continue"
						onClick={this.props.continueLocation}
					/> */}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		// console.log('Create sub payment account call stated...');
		e.preventDefault();
		e.stopPropagation();

		const nameToSend =
			this.state.name !== ''
				? this.state.name
				: this.state.account_type === 'Checking'
					? `${this.props.firstName}'s Checking`
					: `${this.props.firstName}'s Savings`;

		$.ajax({
			type: 'POST',
			url: this.props.endpoint,
			dataType: 'json',
			data: {
				payment_account: {
					property_id: this.props.propertyId,
					name: nameToSend,
					account_type: this.state.account_type,
					account_number: this.state.account_number,
					routing_number: this.state.routing_number,
					account_holder_first_name: this.state.account_holder_first_name,
					account_holder_last_name: this.state.account_holder_last_name
				}
			},
			error: (response) => {
				// console.log('Create payment call failed.', response.responseJSON);
				this.setState({
					// errorsList: response.responseJSON.errors, // Enable for errors list
					fieldErrors: response.responseJSON.field_errors // Enable for field errors
				});
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log(
			// 	'Create sub payment account call successful.',
			// 	response,
			// 	status
			// );
			this.props.continueLocation();
		});
	}
}
